import React from 'react';
import PropTypes from 'prop-types';
import './SaveSelectionBanner.css';

const SaveSelectionBanner = ({ selectedText, onSave, onDismiss, t, isVisible }) => {
  if (!isVisible) {
    return null;
  }

  const snippet = selectedText.length > 50 ? `${selectedText.substring(0, 47)}...` : selectedText;

  return (
    <div className="save-selection-banner">
      <span
        className="banner-text"
        dangerouslySetInnerHTML={{
          __html: t('save_banner_prompt', 'Save "<strong>{{snippet}}</strong>"?', { snippet }),
        }}
      />
      <div className="banner-actions">
        <button onClick={onSave} className="banner-button save">
          {t('save_to_library_button', 'Save to Library')}
        </button>
        <button onClick={onDismiss} className="banner-button dismiss">
          &times;
        </button>
      </div>
    </div>
  );
};

SaveSelectionBanner.propTypes = {
  selectedText: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

export default SaveSelectionBanner;
